import { Title } from '../../utils/title';
import Layout from './Layout';
import styles from './Privacy.module.scss';

const Campaign = () => {
  return (
    <Layout>
      <div className={styles.root}>

        <Title value='General Campaign Terms and Conditions' />

        {
          /*
           * BEGIN HTML
           */
        }
        <div className="d-flex justify-content-center align-items-center text-black">
        <h2 className="card-title text-muted text-black">
            GENERAL CAMPAIGN TERMS AND CONDITIONS
        </h2>
        </div>
        <div className="d-flex justify-content-center align-items-center">
        <h3 className="card-title text-muted pb-3 text-black">
            <u>DETAILS</u>
        </h3>
        </div>
        <h4 className="card-subtitle mb-2 text-muted text-black">PURPOSE OF THE AGREEMENT:</h4>
        <p className="card-text font-weight-bold text-black">
        Chimeable Inc. (Company) would like the Creator’s assistance in creating content and
        promoting the Brand's products via their social media accounts. Company
        hereby appoints the Creator, on a non-employee basis to promote and endorse its products
        to the target consumer.
        </p>
        <h4 className="card-subtitle mb-2 text-muted text-black">ACKNOWLEDGMENT:</h4>
        <p className="card-text font-weight-bold">
        The Company and the Creator acknowledge the terms of this Contract and will comply.
        </p>
        <h4 className="card-subtitle mb-2 text-muted text-black">DELIVERABLES:</h4>
        <p className="card-text font-weight-bold">
        The Creator will deliver the agreed number of posts and creatives on the agreed
        platforms on behalf of the Brand according to the delivery schedule specified by the
        Brand.
        <ul>
            <li>
            The creator agrees to write an honest text review on the retailer website of Brand's
            choice.
            </li>
            <li>Provide Chimeable Inc. with a raw video featuring the product.</li>
            <li>
            The creator agrees to <b>post the final content</b> on their social media account.
            </li>
            <li>
            The creator agrees to follow the <b>Text Review Content guidelines</b> :
            <ul>
                <li>Disclose that she/he received the product for free</li>
                <li>Do not mention this item with food, pets or any other hair care brands</li>
            </ul>
            </li>
        </ul>
        </p>
        <h4 className="card-subtitle mb-2 text-muted text-black">TERM:</h4>
        <p className="card-text font-weight-bold">
        The term of this Agreement shall commence on the effective date of this Agreement.
        Services described above should be done within 14 days of receiving products. Beyond the
        one TikTok post on a public account, the Creator is free to publish any additional
        content, featuring the Brand and its products - with respect to the Brand's intellectual
        property.
        </p>
        <h4 className="card-subtitle mb-2 text-muted text-black">COPYRIGHT:</h4>
        <p className="card-text font-weight-bold">
        Chimeable Inc. and Brand will own the copyright of the uploaded and posted media
        relating to the campaign to use across all Brand marketing outlets including{' '}
        <b>paid media</b> as well as <b>social platforms</b> as organic content.
        </p>
        <h4 className="card-subtitle mb-2 text-muted text-black">NON-SOLICITATION:</h4>
        <p className="card-text font-weight-bold">
        During this campaign as well as a 12 Months period following the end of the current
        campaign, Creator shall not, directly or indirectly, in any manner whatsoever engage in
        any capacity with the Brand without the Company's explicit consent in a written form.
        </p>
        <h4 className="card-subtitle mb-2 text-muted text-black">CONFIDENTIALITY:</h4>
        <p className="card-text font-weight-bold">
        During this campaign as well as a 12 Months period following the end of the current
        campaign, Creator shall not, directly or indirectly, in any manner whatsoever engage in
        any capacity with the Brand without the Company's explicit consent in a written form.
        </p>
        <h4 className="card-subtitle mb-2 text-muted text-black">AMENDMENT:</h4>
        <p className="card-text font-weight-bold">
        This contact can only be changed or modified through the written consent of both parties
        (Brand and Creator).
        </p>
        <h4 className="card-subtitle mb-2 text-muted text-black">GOVERNING LAW:</h4>
        <p className="card-text font-weight-bold">
        This Agreement shall be governed by and construed according to the laws of the State of
        New York.
        </p>
        {
          /*
           * END HTML
           */
        }

      </div>
    </Layout>
  );
};

export default Campaign;